import { endOfDay } from 'date-fns'
import { ITaskStore } from './index'

export default {
  cleaning: [],
  date: endOfDay(new Date()),
  ending: [],
  feeding: {
    breakfast: { adults: 0, kids: 0 },
    dinner: { adults: 0, kids: 0 },
    supper: { adults: 0, kids: 0 },
  },
  loading: true,
  noPayment: [],
  starting: [],
} as ITaskStore
